export { default } from './terpene-info';
